import {
  IS_ADMIN_REPORTS_URL,
  IS_ADMIN_RISKMGMT_URL,
  IS_HOUSE_URL,
  TOGGLE_DARK_MODE,
  FETCH_BETTING_CURRENCY_SUCCESS,
  FETCH_BETTING_CURRENCY_FAILED,
  CASINO_GAME_SELECTED,
  SET_DC_GAME_URL,
  SET_LIVESTREAM_URL,
  SET_PLAY_STREAM,
  SET_ALLOWED_CONFIG,
  ENABLE_COMMISSION,
  TRIGGER_FETCH_BALANCE,
  TRIGGER_FETCH_NOTIFICATIONS,
  FETCH_CONTENT_CONFIG_SUCCESS,
  SET_DOMAIN_CONFIG,
} from './commonActionTypes';
import { CommonState } from '../../models/CommonState';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import { BRAND_NAME } from '../../constants/Branding';
import { Currency } from '../../models/Currency';

type Action = {
  type: string;
  payload: any;
};

const initialState: CommonState = {
  isAdminReportsUrl: false,
  isAdminRiskMgmtUrl: false,
  isHouseUrl: false,
  prefersDark: null,
  bettingCurrency: Currency.Pts,
  currenciesAllowed: null,
  selectedCasinoGame: null,
  tvGamesEnabled: false,
  dcGameUrl: '',
  streamUrl: '',
  playStream: false,
  allowedConfig: CONFIG_PERMISSIONS.sports + CONFIG_PERMISSIONS.casino,
  commissionEnabled: false,
  balanceChanged: null,
  notificationUpdated: null,
  domainConfig: {
    demoUser: false,
    signup: false,
    whatsapp: false,
    payments: false,
    bonus: false,
    casinoEnabled: true,
    sportsEnabled: true,
    isDomainConfigLoading: true,
    userProfileUpdate: true,
    
  },
  contentConfig: null,
};

const commonReducer = (state = initialState, action: Action): CommonState => {
  switch (action.type) {
    case IS_ADMIN_REPORTS_URL:
      return {
        ...state,
        isAdminReportsUrl: action.payload,
      };
    case IS_ADMIN_RISKMGMT_URL:
      return {
        ...state,
        isAdminRiskMgmtUrl: action.payload,
      };
    case IS_HOUSE_URL:
      return {
        ...state,
        isHouseUrl: action.payload,
      };
    case TOGGLE_DARK_MODE:
      return {
        ...state,
        prefersDark: action.payload,
      };

    case SET_PLAY_STREAM:
      return {
        ...state,
        playStream: action.payload,
      };

    case FETCH_BETTING_CURRENCY_SUCCESS:
      return {
        ...state,
        bettingCurrency: action.payload.bettingCurrency,
        currenciesAllowed: action.payload.currenciesAllowed,
      };

    case FETCH_BETTING_CURRENCY_FAILED:
      return {
        ...state,
        bettingCurrency: null,
      };
    case CASINO_GAME_SELECTED:
      return {
        ...state,
        selectedCasinoGame: action.payload,
      };
    case SET_DC_GAME_URL:
      return {
        ...state,
        dcGameUrl: action.payload,
      };
    case SET_LIVESTREAM_URL:
      return {
        ...state,
        streamUrl: action.payload,
      };
    case SET_ALLOWED_CONFIG:
      return {
        ...state,
        allowedConfig: action.payload,
      };
    case ENABLE_COMMISSION:
      return {
        ...state,
        commissionEnabled: action.payload,
      };
    case TRIGGER_FETCH_BALANCE:
      return {
        ...state,
        balanceChanged: action.payload,
      };
    case TRIGGER_FETCH_NOTIFICATIONS:
      return {
        ...state,
        notificationUpdated: action.payload,
      };
    case FETCH_CONTENT_CONFIG_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          contentConfig: action.payload,
        };
      }
    case SET_DOMAIN_CONFIG:
      return {
        ...state,
        domainConfig: action.payload,
      };
    default:
      return state;
  }
};

export default commonReducer;
